module.exports = __webpack_public_path__ + "static/media/NextArticle.056da41d.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/NextArticle.PNG
// module id = 1445
// module chunks = 1